class PrivacyPolicy extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  render() {
    this.innerHTML = `
      <article class="public-page" aria-label="Privacy Policy">
        <header>
          <p>Accountable whimsy, zero surveillance capitalism.</p>
          <h1>Privacy Policy</h1>
          <p>Last updated: ${new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
        </header>

        <section>
          <h2>What we collect</h2>
          <div class="card">
            <strong>Account basics</strong>
            <p>Username, email, and the friends you decide to keep close. If you enable SMS or 2FA we store the necessary numbers/tokens (encrypted, of course).</p>
          </div>
          <div class="card">
            <strong>Posts, events, and prompts</strong>
            <p>Everything you share stays scoped to your intended audience. We keep copies so you, your friends, and future you (hi!) can revisit them.</p>
          </div>
          <div class="card">
            <strong>Guest RSVP info</strong>
            <p>Event hosts can invite people who don’t have Fun Old Times accounts. We store their RSVP name + email strictly so hosts can plan snacks and seating.</p>
          </div>
        </section>

        <section>
          <h2>What we never do</h2>
          <ul>
            <li>We do not use your data to train AI models. If that ever changes, we will explain why and ask you to opt in before any future content is involved.</li>
            <li>We do not sell ads, rent lists, or plug third-party trackers into your friend space.</li>
            <li>We do not secretly make your posts public. Friends-only is a forever feature.</li>
          </ul>
        </section>

        <section>
          <h2>How we use your info</h2>
          <p>Mostly to keep the lights blinking in fun colors:</p>
          <ul>
            <li>Delivering the upcoming-events board so you always know what’s next.</li>
            <li>Sending invitations, reminders, and prompt nudges that you explicitly request.</li>
            <li>Running audit logs so we can spot bugs or bad actors before they ruin the vibe.</li>
          </ul>
        </section>

        <section>
          <h2>Your choices</h2>
          <ul>
            <li>Download or delete your content by asking support@funoldtimes.com (self-serve tools are on our roadmap, we promise).</li>
            <li>Opt out of SMS or email notifications any time in settings.</li>
            <li>Remove guests from events; their RSVP data disappears with the invite.</li>
          </ul>
        </section>

        <section>
          <h2>Security</h2>
          <p>We encrypt data in transit and at rest, require unique session cookies, and audit log critical actions so we can catch bugs or bad behavior before it spreads.</p>
        </section>

        <section>
          <p class="note">Questions? Ping support@funoldtimes.com.</p>
        </section>
      </article>
    `;
  }
}

customElements.define('privacy-policy', PrivacyPolicy);

